<div>
    <ng-material-multilevel-menu
      [configuration]='config' 
      [items]='appitems' 
      (selectedItem)="selectedItem($event)">
    </ng-material-multilevel-menu>
</div>